export default __webpack_public_path__ + "static/media/awChit.6e3af441.svg";